// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;Let not the foot of pride come against me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;nor the hand of the ungodly thrust me away.<br> </p> </div></div>";
// Exports
module.exports = code;